// extracted by mini-css-extract-plugin
export default {"image":"MobileTopBar_image__x9mUg","bannerContainer":"MobileTopBar_bannerContainer__e1mg9","bannerImage":"MobileTopBar_bannerImage__CT5UD"};